import { db } from '@/firebaseConfig'

const state = {
  inventoryCategoriesLoading: false,
  inventoryCategories: [],
}

const getters = {
  inventoryCategories: (state) => {
    return state.inventoryCategories
  },
  inventoryCategoriesLoading: (state) => {
    return state.inventoryCategoriesLoading
  },
}

const mutations = {
  setInventoryCategories(state, newValue) {
    state.inventoryCategories = newValue
  },
  setInventoryCategoriesLoading(state, newValue) {
    state.inventoryCategoriesLoading = newValue
  },
}

const actions = {
  clearInventoryData({ commit }) {
    commit('setInventoryCategories', [])
    commit('setInventoryCategoriesLoading', false)
  },

  async getInventoryCategories({ commit, rootState }, force = false) {
    if (!force && state.inventoryCategories.length > 0) {
      return
    }
    commit('setInventoryCategoriesLoading', true)
    const path = `companies/${rootState.company.companyId}/categories`
    try {
      const snapshot = await db
        .collection(path)
        .orderBy('name')
        .get()
      const categories = snapshot.docs.map((c) => {
        return {
          id: c.id,
          ...c.data(),
        }
      })

      commit('setInventoryCategories', categories)
    } catch (err) {
      console.error(err)
    } finally {
      commit('setInventoryCategoriesLoading', false)
    }
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
